import { render, staticRenderFns } from "./PppoeFttbService.vue?vue&type=template&id=b0558c24&"
import script from "./PppoeFttbService.vue?vue&type=script&lang=js&"
export * from "./PppoeFttbService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports